// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectType_wrapper__MQ5LL"};